import { render, staticRenderFns } from "./SelectNumberOfPersons.vue?vue&type=template&id=6a08c8b6&"
import script from "./SelectNumberOfPersons.vue?vue&type=script&lang=js&"
export * from "./SelectNumberOfPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports